// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SdohModule-module__font-s-10___ACUqO {
  font-size: 10px !important;
}

.SdohModule-module__font-s-12___zGL3z {
  font-size: 12px !important;
}

.SdohModule-module__font-s-13___oSpeO {
  font-size: 13px !important;
}

.SdohModule-module__font-s-14___H3MK2 {
  font-size: 14px !important;
}

.SdohModule-module__font-s-15___ICLe7 {
  font-size: 15px !important;
}

.SdohModule-module__font-s-16___iJjHt {
  font-size: 16px !important;
}

.SdohModule-module__font-s-18___xHEWo {
  font-size: 18px !important;
}

.SdohModule-module__font-s-20___Jyx0k {
  font-size: 20px !important;
}

.SdohModule-module__font-s-22___vM3si {
  font-size: 22px !important;
}

.SdohModule-module__font-s-28___wkbV4 {
  font-size: 28px !important;
}

.SdohModule-module__font-w-400___z3FRq {
  font-weight: 400 !important;
}

.SdohModule-module__font-w-500___bX8ds {
  font-weight: 500 !important;
}

.SdohModule-module__font-w-600___hPIG0 {
  font-weight: 600 !important;
}

.SdohModule-module__font-w-700___m6Y_6 {
  font-weight: 700 !important;
}

.SdohModule-module__p-5___Ky3St {
  padding: 5px !important;
}

.SdohModule-module__p-12___XBxhz {
  padding: 12px !important;
}

.SdohModule-module__p-16___UftTu {
  padding: 16px !important;
}

.SdohModule-module__p-30___ZguY4 {
  padding: 30px !important;
}

.SdohModule-module__p-b-0___x47rt {
  padding-bottom: 0 !important;
}

.SdohModule-module__p-b-5___Ot_5u {
  padding-bottom: 5px !important;
}

.SdohModule-module__p-b-10___a0GOg {
  padding-bottom: 10px !important;
}

.SdohModule-module__p-b-12___Z8TQx {
  padding-bottom: 12px !important;
}

.SdohModule-module__p-b-16___ZYlDa {
  padding-bottom: 16px !important;
}

.SdohModule-module__p-b-18___rcndp {
  padding-bottom: 18px !important;
}

.SdohModule-module__p-b-20___XwETS {
  padding-bottom: 20px !important;
}

.SdohModule-module__p-b-25___q_Wcg {
  padding-bottom: 25px !important;
}

.SdohModule-module__p-b-30___WnKvl {
  padding-bottom: 30px !important;
}

.SdohModule-module__p-b-50___a8ZlZ {
  padding-bottom: 50px !important;
}

.SdohModule-module__p-t-0___o57wx {
  padding-top: 0 !important;
}

.SdohModule-module__p-t-12___KG9Ju {
  padding-top: 12px !important;
}

.SdohModule-module__p-t-16___JIfyb {
  padding-top: 16px !important;
}

.SdohModule-module__p-t-18___lIqFm {
  padding-top: 18px !important;
}

.SdohModule-module__p-t-20___g5KMG {
  padding-top: 20px !important;
}

.SdohModule-module__p-t-30___T20wY {
  padding-top: 30px !important;
}

.SdohModule-module__p-t-40___KdWCB {
  padding-top: 40px !important;
}

.SdohModule-module__p-t-50___KShDv {
  padding-top: 50px !important;
}

.SdohModule-module__p-l-20___o1gVI {
  padding-left: 20px !important;
}

.SdohModule-module__p-l-30___F0nGE {
  padding-left: 30px !important;
}

.SdohModule-module__p-l-40___zXnB7 {
  padding-left: 40px !important;
}

.SdohModule-module__p-r-16___EyH8A {
  padding-right: 16px !important;
}

.SdohModule-module__p-r-20___HmWTh {
  padding-right: 20px !important;
}

.SdohModule-module__p-r-30___LSTwq {
  padding-right: 30px !important;
}

.SdohModule-module__p-r-50___d3aG7 {
  padding-right: 50px !important;
}

.SdohModule-module__p-r-60___Oyv0n {
  padding-right: 60px !important;
}

.SdohModule-module__m-b-1____jz_4 {
  margin-bottom: 1px !important;
}

.SdohModule-module__m-b-2___AT38q {
  margin-bottom: 2px !important;
}

.SdohModule-module__m-b-6___rxbk2 {
  margin-bottom: 6px !important;
}

.SdohModule-module__m-b-8___W2fLh {
  margin-bottom: 8px !important;
}

.SdohModule-module__m-b-10___tsHJh {
  margin-bottom: 10px !important;
}

.SdohModule-module__m-b-14___floaZ {
  margin-bottom: 14px !important;
}

.SdohModule-module__m-b-16___wqV0Z {
  margin-bottom: 16px !important;
}

.SdohModule-module__m-b-20___TGS45 {
  margin-bottom: 20px !important;
}

.SdohModule-module__m-b-22___Sk4mv {
  margin-bottom: 22px !important;
}

.SdohModule-module__m-b-24___lYzpW {
  margin-bottom: 24px !important;
}

.SdohModule-module__m-b-30___XzBi8 {
  margin-bottom: 30px !important;
}

.SdohModule-module__m-b-32___Bj0qm {
  margin-bottom: 32px !important;
}

.SdohModule-module__m-b-40___c2Msb {
  margin-bottom: 40px !important;
}

.SdohModule-module__m-t-2___6XdF9 {
  margin-top: 2px !important;
}

.SdohModule-module__m-t-3___vvIM1 {
  margin-top: 3px !important;
}

.SdohModule-module__m-t-4___uNuy3 {
  margin-top: 4px !important;
}

.SdohModule-module__m-t-5___fjsxb {
  margin-top: 5px !important;
}

.SdohModule-module__m-t-8___XBqT_ {
  margin-top: 8px !important;
}

.SdohModule-module__m-t-10___Tt8m_ {
  margin-top: 10px !important;
}

.SdohModule-module__m-t-15___g8iMg {
  margin-top: 15px !important;
}

.SdohModule-module__m-t-16___w2mql {
  margin-top: 16px !important;
}

.SdohModule-module__m-t-20___hcyZl {
  margin-top: 20px !important;
}

.SdohModule-module__m-t-22___kZKut {
  margin-top: 22px !important;
}

.SdohModule-module__m-t-30___ivp8x {
  margin-top: 30px !important;
}

.SdohModule-module__m-t-32___Hh6EP {
  margin-top: 32px !important;
}

.SdohModule-module__m-l-auto___VJ4QX {
  margin-left: auto !important;
}

.SdohModule-module__m-l-4___Pvm8p {
  margin-left: 4px !important;
}

.SdohModule-module__m-l-5___yLlp3 {
  margin-left: 5px !important;
}

.SdohModule-module__m-l-6___HMi66 {
  margin-left: 6px !important;
}

.SdohModule-module__m-l-8___cJED8 {
  margin-left: 8px !important;
}

.SdohModule-module__m-l-10___vc7qt {
  margin-left: 10px !important;
}

.SdohModule-module__m-l-16___f_560 {
  margin-left: 16px !important;
}

.SdohModule-module__m-l-20___vzR0s {
  margin-left: 20px !important;
}

.SdohModule-module__m-l-24___ErcQp {
  margin-left: 24px !important;
}

.SdohModule-module__m-l-30___E4W3h {
  margin-left: 30px !important;
}

.SdohModule-module__m-l-35___WNhpX {
  margin-left: 35px !important;
}

.SdohModule-module__m-l-40___Sp_mw {
  margin-left: 40px !important;
}

.SdohModule-module__m-r-8___HitrT {
  margin-right: 8px !important;
}

.SdohModule-module__m-r-10___S_VWj {
  margin-right: 10px !important;
}

.SdohModule-module__m-r-16___nbKp6 {
  margin-right: 16px !important;
}

.SdohModule-module__m-r-20___D2z_A {
  margin-right: 20px !important;
}

.SdohModule-module__m-r-24___N38KM {
  margin-right: 24px !important;
}

.SdohModule-module__m-r-30___hAGgu {
  margin-right: 30px !important;
}

.SdohModule-module__m-r-40___ZxRKF {
  margin-right: 40px !important;
}

.SdohModule-module__border-r-3___XVmGn {
  border-radius: 3px !important;
}

.SdohModule-module__border-r-4___vyXQk {
  border-radius: 4px !important;
}

.SdohModule-module__border-r-6___xioIy {
  border-radius: 6px !important;
}

.SdohModule-module__border-r-10___S23gX {
  border-radius: 10px !important;
}

.SdohModule-module__border-r-12___kmT0c {
  border-radius: 12px !important;
}

.SdohModule-module__border-r-16___b9Juw {
  border-radius: 16px !important;
}

.SdohModule-module__border-r-50___M2bVr {
  border-radius: 50% !important;
}

.SdohModule-module__primary-border___upSzA {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SdohModule-module__primary-border-b___VPBt6 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SdohModule-module__primary-border-t___y98UH {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SdohModule-module__primary-border-l___SJ8l6 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SdohModule-module__primary-border-r___AYPrI {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SdohModule-module__secondary-border___wEEFz {
  border: 1px solid #637768;
}

.SdohModule-module__secondary-border-b___ZX03j {
  border-bottom: 1px solid #637768;
}

.SdohModule-module__secondary-border-t___AcBIx {
  border-top: 1px solid #637768;
}

.SdohModule-module__secondary-border-l___KQMgU {
  border-left: 1px solid #637768;
}

.SdohModule-module__secondary-border-r___Uv4qq {
  border-right: 1px solid #637768;
}

.SdohModule-module__gap-0___Rx0Wx {
  gap: 0 !important;
}

.SdohModule-module__gap-2___yQrWM {
  gap: 2px !important;
}

.SdohModule-module__gap-4___hqY2o {
  gap: 4px !important;
}

.SdohModule-module__gap-5___PD1Nn {
  gap: 5px !important;
}

.SdohModule-module__gap-6___y7Tz1 {
  gap: 6px !important;
}

.SdohModule-module__gap-8___DMBJw {
  gap: 8px !important;
}

.SdohModule-module__gap-10___BmHzG {
  gap: 10px !important;
}

.SdohModule-module__gap-12___wKZ7e {
  gap: 12px !important;
}

.SdohModule-module__gap-14___W4YNY {
  gap: 14px !important;
}

.SdohModule-module__gap-16___gf4kw {
  gap: 16px !important;
}

.SdohModule-module__gap-18___eMi7R {
  gap: 18px !important;
}

.SdohModule-module__gap-20____n6Uw {
  gap: 20px !important;
}

.SdohModule-module__gap-24___tiMTJ {
  gap: 24px !important;
}

.SdohModule-module__gap-26___ir3tK {
  gap: 26px !important;
}

.SdohModule-module__gap-30___Ng6N8 {
  gap: 30px !important;
}

.SdohModule-module__gap-32___gcxDo {
  gap: 32px !important;
}

.SdohModule-module__gap-40____Puui {
  gap: 40px !important;
}

.SdohModule-module__gap-50___wwOTc {
  gap: 50px !important;
}

.SdohModule-module__flex-1___vmZBm {
  flex: 1;
}

.SdohModule-module__flex-none___m4O7s {
  flex: none !important;
}

.SdohModule-module__flex-column___xgTfx {
  display: flex;
  flex-direction: column !important;
}

.SdohModule-module__flex-row___ii7I0 {
  display: flex;
  flex-direction: row !important;
}

.SdohModule-module__vertically-centered___APz8x {
  display: flex;
  align-items: center !important;
}

.SdohModule-module__horizontally-centered___dvlvT {
  display: flex;
  justify-content: center !important;
}

.SdohModule-module__horizontally-end___YrlgE {
  display: flex;
  justify-content: end !important;
}

.SdohModule-module__vertically-start___n4bkt {
  display: flex;
  align-items: start !important;
}

.SdohModule-module__space-between___n_NpT {
  display: flex;
  justify-content: space-between !important;
}

.SdohModule-module__flex-wrap___cshyp {
  flex-wrap: wrap !important;
}

.SdohModule-module__height-100___BAkvh {
  height: 100%;
}

.SdohModule-module__width-50___EIGVC {
  width: 50% !important;
}

.SdohModule-module__width-100___fIY2c {
  width: 100%;
}

.SdohModule-module__cursor-pointer___z0Art {
  cursor: pointer;
}

.SdohModule-module__cursor-not-allowed___TmKvQ {
  cursor: not-allowed !important;
}

.SdohModule-module__absolute-centered___XL5Qg {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SdohModule-module__absolute___ji3s8 {
  position: absolute;
}

.SdohModule-module__relative___tBwm9 {
  position: relative;
}

.SdohModule-module__fixed___lyiQ6 {
  position: fixed;
}

.SdohModule-module__visible___XHssm {
  opacity: 1;
}

.SdohModule-module__invisible___XKQik {
  opacity: 0;
}

.SdohModule-module__col-90___JafK2 {
  width: 90% !important;
}

.SdohModule-module__col-auto___qKLPV {
  width: auto !important;
}

.SdohModule-module__medical-tabs___wism6 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SdohModule-module__medical-table-new___oIR7W {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SdohModule-module__medical-table-new___oIR7W:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SdohModule-module__medical-table-new___oIR7W::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SdohModule-module__medical-table-new___oIR7W::-webkit-scrollbar-track {
  display: none;
}
.SdohModule-module__medical-table-new___oIR7W.SdohModule-module__no-pagination___VHXKU {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SdohModule-module__medical-table-new___oIR7W.SdohModule-module__no-pagination___VHXKU:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SdohModule-module__medical-table-new___oIR7W.SdohModule-module__no-pagination___VHXKU::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SdohModule-module__medical-table-new___oIR7W.SdohModule-module__no-pagination___VHXKU::-webkit-scrollbar-track {
  display: none;
}

.SdohModule-module__medical-table-empty___FUqHE {
  padding: 14px 40px !important;
}

.SdohModule-module__icon-btn___t1fWt {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SdohModule-module__search-icon___Ny8Nh {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SdohModule-module__disable-select___c7sLG {
  user-select: none;
}

.SdohModule-module__break-word___FGD7L {
  word-break: break-word;
}

.SdohModule-module__popup-clear-btn___KYUJt {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SdohModule-module__scroll-m-b-20___sX69_ {
  scroll-margin-bottom: 20px;
}

.SdohModule-module__wrapper___uTw3X {
  padding: 0 30px 30px 30px;
}
.SdohModule-module__wrapper___uTw3X .SdohModule-module__instructions___Vgno9 {
  color: #637768;
}
.SdohModule-module__wrapper___uTw3X .SdohModule-module__label___Fadgg {
  color: #375844;
  white-space: pre;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/SdohModule/SdohModule.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;AA3pBE;EACE,cAAA;EACA,gBAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.wrapper {\n  padding: 0 30px 30px 30px;\n\n  .instructions {\n    color: get-color(greenNew, medium-dark);\n  }\n\n  .label {\n    color: get-color(greenNew, dark);\n    white-space: pre;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SdohModule-module__font-s-10___ACUqO`,
	"fontS12": `SdohModule-module__font-s-12___zGL3z`,
	"fontS13": `SdohModule-module__font-s-13___oSpeO`,
	"fontS14": `SdohModule-module__font-s-14___H3MK2`,
	"fontS15": `SdohModule-module__font-s-15___ICLe7`,
	"fontS16": `SdohModule-module__font-s-16___iJjHt`,
	"fontS18": `SdohModule-module__font-s-18___xHEWo`,
	"fontS20": `SdohModule-module__font-s-20___Jyx0k`,
	"fontS22": `SdohModule-module__font-s-22___vM3si`,
	"fontS28": `SdohModule-module__font-s-28___wkbV4`,
	"fontW400": `SdohModule-module__font-w-400___z3FRq`,
	"fontW500": `SdohModule-module__font-w-500___bX8ds`,
	"fontW600": `SdohModule-module__font-w-600___hPIG0`,
	"fontW700": `SdohModule-module__font-w-700___m6Y_6`,
	"p5": `SdohModule-module__p-5___Ky3St`,
	"p12": `SdohModule-module__p-12___XBxhz`,
	"p16": `SdohModule-module__p-16___UftTu`,
	"p30": `SdohModule-module__p-30___ZguY4`,
	"pB0": `SdohModule-module__p-b-0___x47rt`,
	"pB5": `SdohModule-module__p-b-5___Ot_5u`,
	"pB10": `SdohModule-module__p-b-10___a0GOg`,
	"pB12": `SdohModule-module__p-b-12___Z8TQx`,
	"pB16": `SdohModule-module__p-b-16___ZYlDa`,
	"pB18": `SdohModule-module__p-b-18___rcndp`,
	"pB20": `SdohModule-module__p-b-20___XwETS`,
	"pB25": `SdohModule-module__p-b-25___q_Wcg`,
	"pB30": `SdohModule-module__p-b-30___WnKvl`,
	"pB50": `SdohModule-module__p-b-50___a8ZlZ`,
	"pT0": `SdohModule-module__p-t-0___o57wx`,
	"pT12": `SdohModule-module__p-t-12___KG9Ju`,
	"pT16": `SdohModule-module__p-t-16___JIfyb`,
	"pT18": `SdohModule-module__p-t-18___lIqFm`,
	"pT20": `SdohModule-module__p-t-20___g5KMG`,
	"pT30": `SdohModule-module__p-t-30___T20wY`,
	"pT40": `SdohModule-module__p-t-40___KdWCB`,
	"pT50": `SdohModule-module__p-t-50___KShDv`,
	"pL20": `SdohModule-module__p-l-20___o1gVI`,
	"pL30": `SdohModule-module__p-l-30___F0nGE`,
	"pL40": `SdohModule-module__p-l-40___zXnB7`,
	"pR16": `SdohModule-module__p-r-16___EyH8A`,
	"pR20": `SdohModule-module__p-r-20___HmWTh`,
	"pR30": `SdohModule-module__p-r-30___LSTwq`,
	"pR50": `SdohModule-module__p-r-50___d3aG7`,
	"pR60": `SdohModule-module__p-r-60___Oyv0n`,
	"mB1": `SdohModule-module__m-b-1____jz_4`,
	"mB2": `SdohModule-module__m-b-2___AT38q`,
	"mB6": `SdohModule-module__m-b-6___rxbk2`,
	"mB8": `SdohModule-module__m-b-8___W2fLh`,
	"mB10": `SdohModule-module__m-b-10___tsHJh`,
	"mB14": `SdohModule-module__m-b-14___floaZ`,
	"mB16": `SdohModule-module__m-b-16___wqV0Z`,
	"mB20": `SdohModule-module__m-b-20___TGS45`,
	"mB22": `SdohModule-module__m-b-22___Sk4mv`,
	"mB24": `SdohModule-module__m-b-24___lYzpW`,
	"mB30": `SdohModule-module__m-b-30___XzBi8`,
	"mB32": `SdohModule-module__m-b-32___Bj0qm`,
	"mB40": `SdohModule-module__m-b-40___c2Msb`,
	"mT2": `SdohModule-module__m-t-2___6XdF9`,
	"mT3": `SdohModule-module__m-t-3___vvIM1`,
	"mT4": `SdohModule-module__m-t-4___uNuy3`,
	"mT5": `SdohModule-module__m-t-5___fjsxb`,
	"mT8": `SdohModule-module__m-t-8___XBqT_`,
	"mT10": `SdohModule-module__m-t-10___Tt8m_`,
	"mT15": `SdohModule-module__m-t-15___g8iMg`,
	"mT16": `SdohModule-module__m-t-16___w2mql`,
	"mT20": `SdohModule-module__m-t-20___hcyZl`,
	"mT22": `SdohModule-module__m-t-22___kZKut`,
	"mT30": `SdohModule-module__m-t-30___ivp8x`,
	"mT32": `SdohModule-module__m-t-32___Hh6EP`,
	"mLAuto": `SdohModule-module__m-l-auto___VJ4QX`,
	"mL4": `SdohModule-module__m-l-4___Pvm8p`,
	"mL5": `SdohModule-module__m-l-5___yLlp3`,
	"mL6": `SdohModule-module__m-l-6___HMi66`,
	"mL8": `SdohModule-module__m-l-8___cJED8`,
	"mL10": `SdohModule-module__m-l-10___vc7qt`,
	"mL16": `SdohModule-module__m-l-16___f_560`,
	"mL20": `SdohModule-module__m-l-20___vzR0s`,
	"mL24": `SdohModule-module__m-l-24___ErcQp`,
	"mL30": `SdohModule-module__m-l-30___E4W3h`,
	"mL35": `SdohModule-module__m-l-35___WNhpX`,
	"mL40": `SdohModule-module__m-l-40___Sp_mw`,
	"mR8": `SdohModule-module__m-r-8___HitrT`,
	"mR10": `SdohModule-module__m-r-10___S_VWj`,
	"mR16": `SdohModule-module__m-r-16___nbKp6`,
	"mR20": `SdohModule-module__m-r-20___D2z_A`,
	"mR24": `SdohModule-module__m-r-24___N38KM`,
	"mR30": `SdohModule-module__m-r-30___hAGgu`,
	"mR40": `SdohModule-module__m-r-40___ZxRKF`,
	"borderR3": `SdohModule-module__border-r-3___XVmGn`,
	"borderR4": `SdohModule-module__border-r-4___vyXQk`,
	"borderR6": `SdohModule-module__border-r-6___xioIy`,
	"borderR10": `SdohModule-module__border-r-10___S23gX`,
	"borderR12": `SdohModule-module__border-r-12___kmT0c`,
	"borderR16": `SdohModule-module__border-r-16___b9Juw`,
	"borderR50": `SdohModule-module__border-r-50___M2bVr`,
	"primaryBorder": `SdohModule-module__primary-border___upSzA`,
	"primaryBorderB": `SdohModule-module__primary-border-b___VPBt6`,
	"primaryBorderT": `SdohModule-module__primary-border-t___y98UH`,
	"primaryBorderL": `SdohModule-module__primary-border-l___SJ8l6`,
	"primaryBorderR": `SdohModule-module__primary-border-r___AYPrI`,
	"secondaryBorder": `SdohModule-module__secondary-border___wEEFz`,
	"secondaryBorderB": `SdohModule-module__secondary-border-b___ZX03j`,
	"secondaryBorderT": `SdohModule-module__secondary-border-t___AcBIx`,
	"secondaryBorderL": `SdohModule-module__secondary-border-l___KQMgU`,
	"secondaryBorderR": `SdohModule-module__secondary-border-r___Uv4qq`,
	"gap0": `SdohModule-module__gap-0___Rx0Wx`,
	"gap2": `SdohModule-module__gap-2___yQrWM`,
	"gap4": `SdohModule-module__gap-4___hqY2o`,
	"gap5": `SdohModule-module__gap-5___PD1Nn`,
	"gap6": `SdohModule-module__gap-6___y7Tz1`,
	"gap8": `SdohModule-module__gap-8___DMBJw`,
	"gap10": `SdohModule-module__gap-10___BmHzG`,
	"gap12": `SdohModule-module__gap-12___wKZ7e`,
	"gap14": `SdohModule-module__gap-14___W4YNY`,
	"gap16": `SdohModule-module__gap-16___gf4kw`,
	"gap18": `SdohModule-module__gap-18___eMi7R`,
	"gap20": `SdohModule-module__gap-20____n6Uw`,
	"gap24": `SdohModule-module__gap-24___tiMTJ`,
	"gap26": `SdohModule-module__gap-26___ir3tK`,
	"gap30": `SdohModule-module__gap-30___Ng6N8`,
	"gap32": `SdohModule-module__gap-32___gcxDo`,
	"gap40": `SdohModule-module__gap-40____Puui`,
	"gap50": `SdohModule-module__gap-50___wwOTc`,
	"flex1": `SdohModule-module__flex-1___vmZBm`,
	"flexNone": `SdohModule-module__flex-none___m4O7s`,
	"flexColumn": `SdohModule-module__flex-column___xgTfx`,
	"flexRow": `SdohModule-module__flex-row___ii7I0`,
	"verticallyCentered": `SdohModule-module__vertically-centered___APz8x`,
	"horizontallyCentered": `SdohModule-module__horizontally-centered___dvlvT`,
	"horizontallyEnd": `SdohModule-module__horizontally-end___YrlgE`,
	"verticallyStart": `SdohModule-module__vertically-start___n4bkt`,
	"spaceBetween": `SdohModule-module__space-between___n_NpT`,
	"flexWrap": `SdohModule-module__flex-wrap___cshyp`,
	"height100": `SdohModule-module__height-100___BAkvh`,
	"width50": `SdohModule-module__width-50___EIGVC`,
	"width100": `SdohModule-module__width-100___fIY2c`,
	"cursorPointer": `SdohModule-module__cursor-pointer___z0Art`,
	"cursorNotAllowed": `SdohModule-module__cursor-not-allowed___TmKvQ`,
	"absoluteCentered": `SdohModule-module__absolute-centered___XL5Qg`,
	"absolute": `SdohModule-module__absolute___ji3s8`,
	"relative": `SdohModule-module__relative___tBwm9`,
	"fixed": `SdohModule-module__fixed___lyiQ6`,
	"visible": `SdohModule-module__visible___XHssm`,
	"invisible": `SdohModule-module__invisible___XKQik`,
	"col90": `SdohModule-module__col-90___JafK2`,
	"colAuto": `SdohModule-module__col-auto___qKLPV`,
	"medicalTabs": `SdohModule-module__medical-tabs___wism6`,
	"medicalTableNew": `SdohModule-module__medical-table-new___oIR7W`,
	"noPagination": `SdohModule-module__no-pagination___VHXKU`,
	"medicalTableEmpty": `SdohModule-module__medical-table-empty___FUqHE`,
	"iconBtn": `SdohModule-module__icon-btn___t1fWt`,
	"searchIcon": `SdohModule-module__search-icon___Ny8Nh`,
	"disableSelect": `SdohModule-module__disable-select___c7sLG`,
	"breakWord": `SdohModule-module__break-word___FGD7L`,
	"popupClearBtn": `SdohModule-module__popup-clear-btn___KYUJt`,
	"scrollMB20": `SdohModule-module__scroll-m-b-20___sX69_`,
	"wrapper": `SdohModule-module__wrapper___uTw3X`,
	"instructions": `SdohModule-module__instructions___Vgno9`,
	"label": `SdohModule-module__label___Fadgg`
};
module.exports = ___CSS_LOADER_EXPORT___;
